import { getNetworkPassphrase } from 'helpers/env';

import { AssetInfo } from 'types/asset-info';

export const ASSET_CACHE = 'assets';

let network: string;
let metadata: Map<string, AssetInfo>;

export const getAssetMetadataCache = (): Map<string, AssetInfo> => {
    const currentNetwork = getNetworkPassphrase();
    if (!metadata || network !== currentNetwork) {
        try {
            metadata = new Map(JSON.parse(localStorage.getItem(ASSET_CACHE) || '[]'));
        } catch {
            metadata = new Map();
        }
        network = currentNetwork;
    }
    return metadata;
};

export const setAssetMetadataCache = (value: Map<string, AssetInfo>) => {
    network = getNetworkPassphrase();
    metadata = value;
};

export const persistAssetMetadata = () => {
    try {
        localStorage.setItem(ASSET_CACHE, JSON.stringify([...getAssetMetadataCache()]));
    } catch {
        // Metadata stays available in memory when storage is full or disabled.
    }
};
